import { render, staticRenderFns } from "./ViewHouses.vue?vue&type=template&id=b99f9c7c"
import script from "./ViewHouses.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewHouses.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports